<template>
  <ui-dropper
    v-if="modelBlog?.is_editing"
    chevron-left
    @opened="methodBlogWords"
    >
    <template #head>
      <div class="space-x-4">
        <b>Blog</b>
        <span>Words</span>
      </div>
    </template>
    <div class="truncate">
      <table class="table table--modern w-full max-w-full">
        <thead>
          <tr>
            <th class="px-2 py-1" v-text="'Count'"/>
            <th class="px-2 py-1" v-text="'Word'"/>
            <th class="px-2 py-1" v-text="'Linking URL'"/>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(amount, word) in dataBlogWords"
            :key="word"
            >
            <td class="w-0" v-text="amount"/>
            <td class="px-2 py-1 truncate w-0 max-w-80" v-text="word"/>
            <td class="px-2 py-1">
              <ui-text
                :model-value="modelBlog?.meta?.linked_words?.[word]"
                @update:model-value="methodLinkWord(word, $event)"
                />
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
const modelBlog = defineModel<Blog>()

const dataBlogWords = ref<Record<string,string>>();

const methodBlogWords = () => {
  if (modelBlog.value?.id === undefined) {
    return notify({
      text: 'Blog not found',
      type: 'error',
    })
  }

  ws.send('blog.words', {
    id: modelBlog.value.id,
  }).then((res) => {
    dataBlogWords.value = res
  })
}

const methodLinkWord = (word: string, url: any) => {
  methodLinkWordDebounced(word, url)
}

const methodLinkWordDebounced = useDebounce((word: string, link: any) => {
  if (modelBlog.value?.id === undefined) {
    return notify({
      text: 'Blog not found',
      type: 'error',
    })
  }

  ws.send('blog.linkword', {
    id: modelBlog.value.id,
    word,
    link,
  }).then((res) => {
    notify(res)
  })
}, 500)
</script>
